import {useState} from 'react'
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined'
import {FileUploader} from 'react-drag-drop-files'
import * as Styles from './styles'
import Spinner from '../Spinner'

interface IFileProps {
  id: string
  file: HTMLInputElement | null
  setFile: (file: HTMLInputElement) => void
  maxSize?: number
  fileTypes?: Array<string>
  label?: string
  labelUploaded?: string
  isLoading?: boolean
}

const File: React.FC<IFileProps> = ({
  id = 'default',
  maxSize = 5,
  fileTypes = ['JPEG', 'JPG', 'PNG','PDF'],
  label = 'PNG, JPG, JPEG, PDF',
  labelUploaded = 'Upload another?',
  file,
  setFile,
  isLoading = false
}) => {
  const [error, setError] = useState('')

  const handleChange = (file: any) => {
    setFile(file)
    setError('')
  }

  // This function can't test on jest because we can't simulate drag and drop
  // create e2e test to test this functionality
  /* istanbul ignore next */
  const handleTypeError = (error: string) => {
    setError(error)
  }

  const handleSizeError = (error: string) => {
    setError(`${error} - Max size: ${maxSize}mb`)
  }

  return (
    <div>
      <Styles.FileContainer>
        {isLoading ? (
          <Spinner />
        ) : (
          <FileUploader
            handleChange={handleChange}
            name={`input-file-${id}`}
            maxSize={maxSize}
            types={fileTypes}
            dropMessageStyle={{ display: 'none' }}
            onTypeError={handleTypeError}
            onSizeError={handleSizeError}
          >
            <Styles.FileCustom>
              <Styles.FileIcon>
                <CloudUploadOutlinedIcon fontSize="inherit" />
              </Styles.FileIcon>
              <Styles.FileError>{error}</Styles.FileError>
              {!file ? (
                <>
                  <Styles.FileDescription>
                    <Styles.FileDescriptionLink>
                      Click to upload{' '}
                    </Styles.FileDescriptionLink>
                    or drag and drop
                  </Styles.FileDescription>
                  <Styles.FileLabel>{label}</Styles.FileLabel>
                </>
              ) : (
                <Styles.FileLabel>
                  {`${file?.name}`}{' '}
                  <Styles.FileLabelLink>{labelUploaded}</Styles.FileLabelLink>
                </Styles.FileLabel>
              )}
            </Styles.FileCustom>
          </FileUploader>
        )}
      </Styles.FileContainer>
    </div>
  )
}

export default File
